import { Smartphone, Code2, Globe, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SERVICES } from "../lib/data";

const ICONS = { Smartphone, Code2, Globe };

export const Services = () => (
  <section id="services" className="relative py-20 sm:py-28 lg:py-32" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-2xl">
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-laser">
          // Our Core Services
        </span>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-4 mb-4">
          What We Build
        </h2>
        <p className="text-slate-400 text-base leading-relaxed">
          Focused development services designed to help businesses turn ideas into working
          digital products.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mt-12 sm:mt-16">
        {SERVICES.map((service, i) => {
          const Icon = ICONS[service.icon];
          return (
            <Reveal key={service.id} delay={i * 0.12}>
              <div
                data-testid={`service-card-${service.id}`}
                className="group relative h-full rounded-2xl border border-border-subtle bg-card-dark/70 p-6 sm:p-8 hover:border-laser/50 hover:bg-card-hover/80 transition-colors duration-300 hover:shadow-[0_0_40px_-12px_rgba(0,240,255,0.35)]"
              >
                <div className="h-12 w-12 rounded-xl bg-electric/15 border border-electric/30 flex items-center justify-center mb-6 group-hover:bg-electric/25 transition-colors duration-300">
                  <Icon size={24} className="text-laser" />
                </div>
                <h3 className="font-display text-xl font-semibold text-white mb-3">
                  {service.title}
                </h3>
                <p className="text-slate-400 text-sm leading-relaxed mb-5">
                  {service.description}
                </p>
                <ul className="space-y-2">
                  {service.examples.map((ex) => (
                    <li key={ex} className="flex items-start gap-2 text-sm text-slate-500">
                      <ArrowUpRight size={14} className="text-laser mt-0.5 shrink-0" />
                      {ex}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
